import * as moment from 'moment';

export class MissingPlayer {
    id: number;
    begin: moment.Moment;
    end: moment.Moment;
    type: string;
    playerId: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/missing-player.model.ts